import { useAsync } from "@react-hookz/web";
import { useEffect, useState } from "react";
import { useHalls } from "store/Halls.context";

import { AxiosResponse } from "axios";
import { PlateData } from "../../../../backend/src/plates/types";

export const usePlateData = (
  getPlateData: (hallId: string) => Promise<AxiosResponse<PlateData[]>>
) => {
  const { selectedHallId } = useHalls();
  const [plateData, setPlateData] = useState<PlateData[]>([]);

  const [, { execute: doFetchExcludedPlates }] = useAsync(async () => {
    if (!selectedHallId) return;
    const response = await getPlateData(selectedHallId || "");
    if (response.data) setPlateData(response.data);
  });

  // initial fetch
  useEffect(() => {
    doFetchExcludedPlates();
  }, [doFetchExcludedPlates, selectedHallId]);

  return {
    plateData,
    setPlateData,
  };
};
